export default __webpack_public_path__ + "static/media/IconDesc_HyperTube_WallSupport.256.957aa341.png";